import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
/**
 * this service is for announcing polite status messages thru screen readers, e.g. when loading starts/finishes etc.
 * You need to embed the <ig-a11y-status /> component somewhere in your app.component
 */
export class A11yStatusService {
  status = signal('');

  #timeout?: number;
  #timeoutHighPrio?: number;

  /**
   * announce a new status which the screenreader will read when the current reading is finished
   */
  announce(text: string, highPrio = false) {
    if (this.#timeoutHighPrio && !highPrio) {
      // there is a high prio message ongoing skip other incoming
      return;
    }

    if (highPrio) {
      // highPrio messages should stay at least 3sec to ensure it is read
      if (this.#timeoutHighPrio) {
        window.clearTimeout(this.#timeoutHighPrio); // high prio messages override existing high prios
      }
      this.#timeoutHighPrio = window.setTimeout(() => {
        this.#timeoutHighPrio = undefined;
      }, 3000)
    }

    if (this.#timeout) {
      window.clearTimeout(this.#timeout);
    }
    this.#timeout = window.setTimeout(() => {
      this.status.set(text);
    }, 1000);
  }
}
